module.exports = __webpack_public_path__ + "static/media/mediafest.afa20c8f.png";